export enum NotifyLevel {
  None = "None",
  Medium = "Medium",
  High = "High",
}
